import { unix } from '../../utils/datetime';
import { ClassesAPI } from './api-types';
import { CLASS_END_TIME_OFFSET } from './constants';
import { Class, ClassStatus } from './types';

export function getClassStatus({
  scheduledEndTime,
  scheduledStartTime,
  status,
}: {
  scheduledEndTime: UnixTime;
  scheduledStartTime: UnixTime;
  status: ClassStatus;
}) {
  const now = unix();

  const endTime = scheduledEndTime;

  if (scheduledStartTime <= now && now < endTime + CLASS_END_TIME_OFFSET) {
    return ClassStatus.IN_SESSION;
  }

  if (endTime <= now) {
    return ClassStatus.CLOSED;
  }

  return status;
}

export function getClassAttendance({
  attendance,
}: {
  attendance: ClassesAPI.ClassAttendance | undefined;
}): Class['attendance'] {
  if (!attendance || !attendance.inProgress) {
    return {
      inProgress: false,
      markedInStudents: 0,
      numOfAttempts: 0,
    };
  }

  return {
    inProgress: true,
    startedAt: attendance.attendanceTime,
    markedInStudents: 0,
    numOfAttempts: 0,
  };
}

export function classFactory(apiClass: ClassesAPI.APIClass, attendance?: ClassesAPI.ClassAttendance): Class {
  const { classId, scheStartTime, scheEndTime, status } = apiClass;
  return {
    id: classId,
    startTime: scheStartTime,
    endTime: scheEndTime,
    status: getClassStatus({
      status,
      scheduledStartTime: scheStartTime,
      scheduledEndTime: scheEndTime,
    }),
    attendance: getClassAttendance({ attendance }),
    attendanceInProgress: attendance?.inProgress
      ? {
          isInProgress: true,
          isProxy: Boolean(attendance.isProxy),
          available: attendance.numAvailable,
          present: attendance.numPresent,
          enrolled: attendance.numEnrolled,
          startedAt: attendance.attendanceTime,
          nowMarkedPresent: 0,
          failures: [],
          failuresLastSyncedAt: -1,
        }
      : null,
  };
}
